<kehe-phoenix-welcome-banner [disableAnimation]="false" class="events-banner">
  <ng-template #titleBlock>
    Welcome to KeHE CONNECT Supplier<em
      class="trademark-logo far fa-registered"
    ></em
    >!
  </ng-template>
  <ng-template #subheaderBlock>
    <div class="body">
      <div class="description">
        {{ eventsBannerDescription$ | async }}
      </div>
      <div>
        <kehe-phoenix-button
          (click)="onManageOrdersBtnClick()"
          classAttr="btn btn-secondary btn-small"
        >
          Manage Orders
        </kehe-phoenix-button>
      </div>
    </div>
  </ng-template>
</kehe-phoenix-welcome-banner>
